<template>
  <div
    class="d-flex flex-column align-start justify-start tree-item"
    :class="[leftPadding, !isChild ? 'pr-1' : '']"
  >
    <div class="d-flex align-center justify-start tree-item-action pl-1">
      <v-icon
        v-if="option.children?.length"
        :icon="isOpen ? '$chevron-down' : '$chevron-right'"
        :size="20"
        class="chevron-icon"
        @click="isOpen = !isOpen"
      />
      <DpplSimpleCheckbox
        v-model="selectedModel"
        :option="option"
      >
        <template #option-label="{ option: slotOption }">
          <slot
            name="option-label"
            :option="slotOption"
          />
        </template>
      </DpplSimpleCheckbox>
    </div>
    <TreeItemChildren
      v-if="option.children?.length && isOpen"
      :option="option"
      :selected="selected"
      :id-key="idKey"
      :level-has-children="anyHaveChildren"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script setup>
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';
import { computed, ref, defineAsyncComponent } from 'vue';

const TreeItemChildren = defineAsyncComponent(() => import('@/components/filter/treeSelectNewDesign/TreeItemChildrenNew.vue'));

const props = defineProps({
  option: {
    type: Object,
    default: () => ({}),
  },
  selected: {
    type: Array,
    default: () => ([]),
  },
  isChild: {
    type: Boolean,
    default: false,
  },
  levelHasChildren: {
    type: Boolean,
    default: false,
  },
  idKey: {
    type: String,
    default: 'id',
  },
});

const emits = defineEmits(['update:modelValue']);

// State
const isOpen = ref(false);

// Computed
const selectedModel = computed({
  get: () => props.selected.some(({ [props.idKey]: id }) => id === props.option[props.idKey]),
  set: (value) => {
    if (value) {
      emits('update:modelValue', [...props.selected, props.option]);
    } else {
      emits('update:modelValue', props.selected.filter(({ [props.idKey]: id }) => id !== props.option[props.idKey]));
    }
  },
});

const leftPadding = computed(() => {
  if (!props.isChild && props.levelHasChildren && !props.option.children?.length) return 'pl-5';
  if (
    (!props.isChild && !props.levelHasChildren)
    || props.option.children?.length
  ) return 'pl-0';
  return 'pl-4';
});

const anyHaveChildren = computed(() => (props.option.children || [])
  .some((option) => option.children?.length));

</script>

<style scoped lang="less">
.tree-item {
  width: 100%;
}

.tree-item-action {
  min-width: 100%;
  min-height: 32px;

  &:hover {
    background: rgba(@icon-brand, .05);
  }

  :deep(svg) path {
    fill: @icon-default;
  }
}

:deep(input[type=checkbox]) {
  min-width: 15px;
  min-height: 15px;
  width: 15px;
  height: 15px;

  &::before {
    left: 4px;
    width: 5px;
    height: 9px;
  }
}

:deep(label) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: @text-light;
}

.children {
  width: 100%;
}
</style>
